
import { EVENTS } from '../../../../shared/Events';

class SnowOverlay extends PIXI.Sprite {
  constructor(texture) {
    super(texture);

    // vars


    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // props
    this.visible = false;

    // signals
    aScene.signals.sceneCallMain.add(this.callMainFc, this);
  }

  // --------------------------------------------------------------
  // Show/Hide
  // --------------------------------------------------------------

  showOverlay() {
    TweenMax.killTweensOf(this);
    this.visible = true;
    this.alpha = 1;
    // hide with delay
    TweenMax.to(this, 3.0, {
      alpha: 0.0,
      delay: 20,
      onComplete: this.hideOverlayEnd,
      onCompleteScope: this,
    });
  }

  hideOverlayEnd() {
    this.visible = false;
  }

  // --------------------------------------------------------------
  // Main Call
  // --------------------------------------------------------------

  callMainFc(sgType) {
    switch (sgType) {
      case EVENTS.MOVE_TO_TOWN_START:
        if (aScene.sceneManager.snowMain > 0.8) {
          this.showOverlay();
        }
        break;
      default:
    }
  }
}

export default SnowOverlay;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/SnowOverlay.js